<bt-navbar #navbar [title]="title">
  <ng-container signedInRightAlign>
    <a *hasAccess="['user', 'skybox_level_1']" mat-button routerLink="/sites">Facilities</a>
    <button *hasAccess="['verifier', 'depot']" [matMenuTriggerFor]="manufacturingMenu" mat-button>Manufacturing</button>
    <a *hasAccess="['organization_admin', 'Organization Executive', 'Regional Manager', 'Store Manager', 'IT']" mat-button routerLink="/users">Users</a>
  </ng-container>

  <ng-container smallScreenItems>
    @if (authService.hasCurrentUser()) {
      <button #navMenuButton mat-icon-button #navMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"
        fxHide="false" fxHide.gt-md>
        <mat-icon>menu</mat-icon>
      </button>
    }

    <mat-menu #menu xPosition="before">
      <a *hasAccess="['user', 'skybox_level_1']" mat-menu-item routerLink="/sites">Facilities</a>
      <button *hasAccess="['verifier', 'depot']" mat-menu-item [matMenuTriggerFor]="manufacturingMenu">Manufacturing</button>
      <a *hasAccess="['organization_admin', 'Organization Executive', 'Regional Manager', 'Store Manager', 'IT']" mat-menu-item routerLink="/users">Users</a>
      <a mat-menu-item routerLink="users/profile">Profile</a>
      <button mat-menu-item (click)="navbar.signOut()">Sign Out</button>
    </mat-menu>

    <mat-menu #manufacturingMenu [overlapTrigger]="false">
      <a *hasAccess="['verifier', 'depot']" mat-menu-item routerLink="/verification/provision-robot">Provision Robot</a>
      <a *hasAccess="['verifier', 'depot']" mat-menu-item routerLink="/verification">Robot Verification</a>
      <a *hasAccess="['verifier', 'depot']" mat-menu-item routerLink="/verification/verification-suites">Verification Suites</a>
    </mat-menu>

  </ng-container>
</bt-navbar>

<main class="content-container">
  <router-outlet></router-outlet>
</main>
